// extracted by mini-css-extract-plugin
export default {"container":"Group_container__PhMjG","title":"Group_title__cF2ja","row":"Group_row__QVjOv","button":"Group_button__WdBSx"};